import { FC, useMemo } from "react";
import {
  TableBody,
  TableCell,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { useAppSelector } from "@/store/hooks";
import { dimensionCategoriesIdsWithNamesSelector } from "@/store/dimensions/selectors/slice-data/categories/dimensionCategoriesIdsWithNamesSelector";
import { generateShareAmountsForSharedCost } from "@/components/pages/dimensions/utils/helpers/shared-cost/generateShareAmountsForSharedCost";

export const DimensionCostAllocationCardSharedAmountsTableEvenBody: FC = () => {
  const categoryNamesWithIds = useAppSelector(
    dimensionCategoriesIdsWithNamesSelector,
  );

  const data = useMemo(() => {
    return generateShareAmountsForSharedCost(Object.keys(categoryNamesWithIds));
  }, [categoryNamesWithIds]);

  return (
    <TableBody>
      {Object.entries(categoryNamesWithIds).map(([id, name], i) => {
        return (
          <TableRow key={id}>
            <TableCell sx={{ py: 1, width: "50%" }}>{name}</TableCell>
            <TableCell sx={{ py: 1, width: "50%" }}>
              <TextField
                disabled
                variant="outlined"
                value={data?.at(i)?.share_amount ?? ""}
                size="xsmall"
                InputProps={{
                  endAdornment: <Typography ml={0.5}>%</Typography>,
                }}
              />
            </TableCell>
          </TableRow>
        );
      })}
    </TableBody>
  );
};
